// extracted by mini-css-extract-plugin
module.exports = {"root":"_1NCyk","iframeHolder":"uqHGn","iframe":"_3HLqS"};